import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { MosTask } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface GetTasksParams {
  loanId: string;
  limit?: number;
  cursor?: string;
}

interface GetTasksResponse {
  success: boolean;
  tasks: MosTask[];
  nextCursor?: string;
}

const getTasks: QueryFunction<
  GetTasksResponse,
  ['/tasks', GetTasksParams]
> = async (args) => {
  if (isMockServices()) return await mock(_mockData);

  const params = args.queryKey[1];
  const queryParams = new URLSearchParams({
    loanId: params.loanId,
    ...(params.limit && { limit: params.limit.toString() }),
    ...(params.cursor && { cursor: params.cursor }),
  });

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GetTasksResponse>(
    `/tasks?${queryParams.toString()}`,
    {
      method: 'GET',
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to fetch loans');
};

export default getTasks;

const _mockData: GetTasksResponse = {
  success: true,
  tasks: new Array(10).fill(null).map(() => ({
    id: crypto.randomUUID(),
    loanId: crypto.randomUUID(),
    serviceName: 'Mock Service',
    status: 'pending',
    retries: Math.floor(Math.random() * 5), // NOSONAR - Safe for mock data generation
    maxRetries: 5,
    createdAt: new Date().toISOString(),
    priority: 'normal',
    assignedTo: 'John M',
    references: {
      payload: {
        mockData: 'This is a mock payload',
      },
    },
    finishedAt: new Date(
      Date.now() + Math.floor(Math.random() * 10000000), // NOSONAR - Safe for mock data generation
    ).toISOString(),
  })),
  nextCursor: 'emg2cGZqbWE1eXV2ajV3Z3R3bXpnYW1l',
};
